const map = {
	"./embryonic.jpeg": 9367,
	"./generate.jpeg": 9610,
	"./mr.jpeg": 582,
	"./myjunior.jpeg": 198,
	"./pevc.jpeg": 5205,
	"./secondary.jpeg": 9149,
	"./sustainability.jpeg": 2292,
	"./ue.jpeg": 9703,
	"./va.jpeg": 3884
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2866;